import React from 'react'
import injectSheet from 'react-jss'

const FormInputContainer = (props) => {
  const {
    children,
    classes,
    forHtml,
    label,
    right,
    filled,
    width = 100,
  } = props

  return (
    <div
      className={`${classes.inputContainer} ${right && 'right'} ${filled && 'filled'}`}
      style={{ width: `${width}%` }}
    >
      {label ? (
        <React.Fragment>
          {forHtml ? (
            // eslint-disable-next-line
            <label htmlFor={forHtml}>
              <div className={`${classes.labelText}`}>{label}</div>
              {children}
            </label>
          ) : (
            <React.Fragment>
              <div className={`${classes.pseudoLabel}`}>{label}</div>
              {children}
            </React.Fragment>
          )}
        </React.Fragment>
      ) : (
        <React.Fragment>
          {children}
        </React.Fragment>
      )}
    </div>
  )
}

const styles = theme => ({
  inputContainer: {
    position: 'relative',
    padding: `${theme.sizes.gutter / 8}px`,
    marginTop: `${theme.sizes.gutter / 2}px`,
    '&.filled $labelText': {
      fontSize: '60%',
      color: theme.colors.main_3,
      transform: 'translateY(-100%)',
    },
    '&.right $labelText': {
      left: 'unset',
      right: `${theme.sizes.gutter / 2}px`,
    },
    '& input, & textarea, & .selectInput': {
      width: '100%',
      backgroundColor: theme.colors.main_2,
      color: theme.colors.secondary_3b,
      borderColor: theme.colors.secondary_3a,
      borderWidth: '3px',
      borderStyle: 'solid',
      borderRadius: '5px',
      fontSize: '1em',
      padding: `${theme.sizes.gutter / 4}px`,
      '&.is-invalid-input': {
        borderColor: theme.colors.main_1,
        color: theme.colors.main_1,
      },
    },
    '& input[type=files]': {
      borderColor: 'red',
    },
    '& textarea': {
      minHeight: '100px',
      width: '100%',
    },
    '& span': {
      display: 'none',
    },
    '& button': {
      height: '100%',
      backgroundColor: theme.colors.main_1,
      color: theme.colors.main_2,
      fontSize: '1em',
      borderColor: theme.colors.main_1,
      borderWidth: '3px',
      borderStyle: 'solid',
      borderRadius: '5px',
      padding: `${theme.sizes.gutter / 4}px ${theme.sizes.gutter}px`,
      transition: [
        {
          property: 'opacity',
          duration: theme.speed.fast,
        },
        {
          property: 'color',
          duration: theme.speed.fast,
        },
        {
          property: 'background-color',
          duration: theme.speed.fast,
        },
      ],
      '&:hover': {
        backgroundColor: theme.colors.main_2,
        color: theme.colors.main_1,
      },
      '&:disabled': {
        opacity: 0,
      },
    },
  },
  labelText: {
    display: 'block',
    position: 'absolute',
    fontSize: '100%',
    color: theme.colors.main_3,
    top: 0,
    left: `${theme.sizes.gutter / 2}px`,
    transform: 'translateY(80%)',
    transition: [
      {
        property: 'transform',
        duration: theme.speed.fast,
        timingFunction: theme.motion.deceleration,
      },
      {
        property: 'color',
        duration: theme.speed.fast,
      },
      {
        property: 'font-size',
        duration: theme.speed.fast,
        timingFunction: theme.motion.deceleration,
      },
    ],
  },
  pseudoLabel: {
    display: 'block',
    position: 'absolute',
    top: 0,
    left: `${theme.sizes.gutter / 2}px`,
    fontSize: '60%',
    color: theme.colors.main_3,
    transform: 'translateY(-100%)',
  },
})

export default injectSheet(styles)(FormInputContainer)



// WEBPACK FOOTER //
// ./src/modules/core/components/formInputContainer.jsx